import { render, staticRenderFns } from "./_mainfeatures.vue?vue&type=template&id=c9987f2e"
import script from "./_mainfeatures.vue?vue&type=script&lang=js"
export * from "./_mainfeatures.vue?vue&type=script&lang=js"
import style0 from "./_mainfeatures.vue?vue&type=style&index=0&id=c9987f2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports